import DeliveryOrder from '@/models/DeliveryOrder/DeliveryOrder';

export default class DeliveryOrderFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.doNumber = '';
		this.doDateFrom = '';
		this.doDateTo = '';
		this.deliveryOrderStatusId  = '';
		this.deliveryOrderStatusName = '';
		this.customerId  = '';
		this.customerCode = '';
		this.remarksMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			doNumber : '0',
			doDateFrom : '0',
			doDateTo : '0',
			deliveryOrderStatusId : '0',
			deliveryOrderStatusName : '0',
			customerId : '0',
			customerCode : '0',
			remarksMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}